import { ThemeEnum } from '@app/common';
import { DefaultTheme } from 'styled-components';
import { color } from '../colors';

export const createAutocomplete = (t: ThemeEnum) => {
    const autocomplete: DefaultTheme['autocomplete'] = {
        base: {
            open: {
                background: color[t].light.gray,
                color: color[t].base.text,
            },
        },
        hover: {
            open: {
                background: color[t].darken.gray,
                color: color[t].base.white,
            },
        },
    };
    return autocomplete;
};
